import { MATRIX_APP_ORIGIN_MAP, REPORT_COMMENT_INFO } from './const';

type KnownMatrixAppOrigin = (typeof MATRIX_APP_ORIGIN_MAP)[keyof typeof MATRIX_APP_ORIGIN_MAP];

export const getReportCommentUrl = (content: string, resourceUrl: string, userId: string) => {
	return `${REPORT_COMMENT_INFO.url}&${REPORT_COMMENT_INFO.content}=${encodeURIComponent(content)}&${REPORT_COMMENT_INFO.resourceUrl}=${encodeURIComponent(resourceUrl)}&${REPORT_COMMENT_INFO.userId}=${encodeURIComponent(userId)}`;
};

export const MATRIX_APP_ORIGIN_OPTIONS = Object.entries(MATRIX_APP_ORIGIN_MAP).map(
	([key, value]) => ({
		label: `${key} (${value})`,
		value,
	}),
);

export const MATRIX_APP_ORIGIN_VALUES = Object.values(MATRIX_APP_ORIGIN_MAP) as string[];

export const isMatrixAppOrigin = (value: string): value is KnownMatrixAppOrigin =>
	MATRIX_APP_ORIGIN_VALUES.includes(value);
